
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade",
      function () {
        return require("private-next-pages/trade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade"])
      });
    }
  